import type { SubmitHandler, UseFormSetError } from 'react-hook-form';
import { Alert, Button, Modal } from '@/shared/components';
import { PlanForm } from './PlanForm';
import type { PlanFormInput, PlanFormOutput } from '../schemas/plan.schema';

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: SubmitHandler<PlanFormOutput>;
    isLoading?: boolean;
    error?: string | null;
    onSetErrorRef?: (setError: UseFormSetError<PlanFormInput>) => void;
}

export function CreatePlanModal({ isOpen, onClose, onSubmit, isLoading = false, error = null, onSetErrorRef }: Props) {
    return (
        <Modal isOpen={isOpen} onClose={onClose} ariaLabelledBy="create-plan-heading" className="max-w-lg p-6">
            <div className="space-y-4">
                <h2 id="create-plan-heading" className="text-lg font-semibold">New Plan</h2>
                <p className="text-sm text-mp-muted">
                    The plan is attached to this product once created.
                </p>

                {error && (
                    <Alert variant="error">
                        <span>{error}</span>
                    </Alert>
                )}

                <PlanForm
                    onSubmit={onSubmit}
                    isLoading={isLoading}
                    submitLabel="Create Plan"
                    onSetErrorRef={onSetErrorRef}
                />

                <Button size="sm" variant="outline" type="button" onClick={onClose} disabled={isLoading}>
                    Cancel
                </Button>
            </div>
        </Modal>
    );
}
